export enum FeatureFlag {
  SkipMoreTabletRequest = 'skipMoreTabletRequest',
  ShowLandingPage = 'showLandingPage',
  SkipCustomerCountSelection = 'skipCustomerCountSelection',
  UseSimplePaymentProcess = 'useSimplePaymentProcess',
  MenuDealsEnabled = 'menu_deals_enabled',
  MenuUpgradesEnabled = 'menu_upgrades_enabled',
  ShopOrderingEnabled = 'shop_ordering_enabled',
  /** MenuCatShop pay-online checkout option (missing or off in PostHog hides it). */
  ShopOnlinePaymentEnabled = 'shop_online_payment_enabled',
  /** MenuCatShop pay-on-pickup checkout option (missing or off in PostHog hides it). */
  ShopPayOnPickupEnabled = 'shop_pay_on_pickup_enabled',
  ShowOpenCartRecommendations = 'showOpenCartRecommendations',
  ShowAddToCartRecommendations = 'showAddToCartRecommendations',
  AvailableLanguages = 'availableLanguages',
  ShowLogo = 'showLogo',
  ShowReleaseTableInCompanion = 'showReleaseTableInCompanion',
  ShowReleaseTablePin = 'showReleaseTablePin',
  /** Companion FAB pay button (missing or off in PostHog hides it). */
  ShowPay = 'showPay',
  /** Companion call-staff button in the FAB and payment modal (missing or off in PostHog hides it). */
  ShowCallStaff = 'showCallStaff',
  showRating = 'showRating',
  Gainback = 'gainback',
  ShowGamificationPayment = 'showGamificationPayment',
  /** Aera Companion kitchen/bar ticket print after successful order (flag = on/off). */
  KitchenTicketPrint = 'kitchenTicketPrint',
  /** Portal pay-bill notification line items (missing or off in PostHog hides them). */
  ShowPaymentNotificationItems = 'showPaymentNotificationItems',
  TapToPayEnabled = 'tapToPay_enabled',
  ShowSplitEqually = 'showSplitEqually',
  orderPaymentEnabled = 'orderPaymentEnabled',
}

/** PostHog payload for KitchenTicketPrint — printer target only (no nested enabled). */
export interface KitchenPrinterTarget {
  host: string;
  port: number;
  categories?: string[];
  width?: number;
  codePage?: string;
}
